import { connect } from 'react-redux';
import _ from 'lodash';
import { getItems } from 'routes/admin/actions';

import ResultPage from './ResultPage';

const mapState = state => ({
	items: state.items.data,
	selection: state.selection,
	user: state.user,
	songsCategory: _.find(state.categories.data, { order: 0 }),
});

const mapDispatch = {
	getItems,
};

/* eslint-disable-next-line */
export default connect(mapState, mapDispatch)(ResultPage);
